import * as _ from 'lodash';
import * as React from 'react';
import { Card, Col, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { AvidEditor } from '../../components/avids/AvidEditor';
import { AvidsDataGrid } from '../../components/avids/AvidsDataGrid';
import { UploadAvids } from '../../components/avids/UploadAvids';
import { HierarchiesDataGrid } from '../../components/hierarchies/HierarchiesDataGrid';
import { HierarchyEditor } from '../../components/hierarchies/HierarchyEditor';
import { LazyTabPane } from '../../components/LazyTabPane';
import { SegmentEditor } from '../../components/segments/SegmentEditor';
import { SegmentsDataGrid } from '../../components/segments/SegmentsDataGrid';
import { UploadSegments } from '../../components/segments/UploadSegments';
import { HierarchyStudiesEditor } from '../../components/studies/HierarchyStudiesEditor';
import { ContentCardHeader } from '../../components/ui/ContentCardHeader';
import { GridContainer } from '../../components/ui/Grid';
import { SegmentsGrid } from 'containers/SegmentsGridContainer';
import { UpdateHistoricalNames } from "../../components/individual-surveys/UpdateHistoricalNames";

interface IManageAvidsHierarchiesAndSegmentsState {
  activeTab: string
}

export class ManageAvidsHierarchiesAndSegmentsContainer extends React.Component<{}, IManageAvidsHierarchiesAndSegmentsState> {
  tabs = {
    Avids: 'Avids',
    Hierarchies: 'Hierarchies',
    HierarchyStudies: 'Hierarchy Studies',
    Segments: 'Segments',
    SegmentsGrid: 'Segments Grid',
    UploadAvids: 'Upload Avids',
    UploadSegments: 'Upload Segments',
    AddAvid: 'Add Avid',
    AddHierarchy: 'Add Hierarchy',
    AddSegment: 'Add Segment',
    UpdateHistoricalNames: 'Update Historical Names',
  }

  state: IManageAvidsHierarchiesAndSegmentsState = {
    activeTab: this.tabs.Avids,
  }

  contentElement: HTMLElement

  setActiveTab(activeTab: string) {
    if (this.contentElement) {
      this.contentElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' })
    }

    this.setState({ activeTab })
  }

  render() {
    const { activeTab } = this.state

    return (
      <section className="blacklight page-bg page-container">
        <GridContainer>
          <Row>
            <Col md={4} lg={3} xl={2}>
              <Nav pills className="flex-column sticky-top-md-1 mb-4">
                {_.values(this.tabs).map((tab) =>
                  <NavItem key={tab}>
                    <NavLink
                      href="javascript:void(0)"
                      active={activeTab === tab}
                      onClick={() => this.setActiveTab(tab)}>
                      <h5 className="mb-0">{tab}</h5>
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
            </Col>
            <Col>
              <section ref={(contentElement) => this.contentElement = contentElement}>
                <LazyTabPane activeTab={activeTab} tabId={this.tabs.Avids} className="subtleSlideInRight">
                  <AvidsDataGrid />
                </LazyTabPane>
                <LazyTabPane activeTab={activeTab} tabId={this.tabs.Hierarchies} className="subtleSlideInRight">
                  <HierarchiesDataGrid />
                </LazyTabPane>
                <LazyTabPane activeTab={activeTab} tabId={this.tabs.HierarchyStudies} className="subtleSlideInRight">
                  <HierarchyStudiesEditor />
                </LazyTabPane>
                <LazyTabPane activeTab={activeTab} tabId={this.tabs.Segments} className="subtleSlideInRight">
                  <SegmentsDataGrid />
                </LazyTabPane>
                <LazyTabPane activeTab={activeTab} tabId={this.tabs.SegmentsGrid} className="subtleSlideInRight">
                  <SegmentsGrid />
                </LazyTabPane>
                <LazyTabPane activeTab={activeTab} tabId={this.tabs.UploadAvids} className="subtleSlideInRight">
                  <UploadAvids />
                </LazyTabPane>
                <LazyTabPane activeTab={activeTab} tabId={this.tabs.UploadSegments} className="subtleSlideInRight">
                  <UploadSegments />
                </LazyTabPane>
                <LazyTabPane activeTab={activeTab} tabId={this.tabs.AddAvid} className="subtleSlideInRight">
                  <Card>
                    <ContentCardHeader header="Add Avid" sticky borderBottom />
                    <AvidEditor
                      onSuccess={() => this.setActiveTab(this.tabs.Avids)}
                      onCancel={() => this.setActiveTab(this.tabs.Avids)} />
                  </Card>
                </LazyTabPane>
                <LazyTabPane activeTab={activeTab} tabId={this.tabs.AddHierarchy} className="subtleSlideInRight">
                  <Card>
                    <ContentCardHeader header="Add Hierarchy" sticky borderBottom />
                    <HierarchyEditor
                      onSuccess={() => this.setActiveTab(this.tabs.Hierarchies)}
                      onCancel={() => this.setActiveTab(this.tabs.Hierarchies)} />
                  </Card>
                </LazyTabPane>
                <LazyTabPane activeTab={activeTab} tabId={this.tabs.AddSegment} className="subtleSlideInRight">
                  <Card>
                    <ContentCardHeader header="Add Segment" sticky borderBottom />
                    <SegmentEditor
                      onSuccess={() => this.setActiveTab(this.tabs.Segments)}
                      onCancel={() => this.setActiveTab(this.tabs.Segments)} />
                  </Card>
                </LazyTabPane>
                <LazyTabPane
                  activeTab={activeTab}
                  tabId={this.tabs.UpdateHistoricalNames}
                  className="subtleSlideInRight"
                >
                  <Card>
                    <ContentCardHeader header="Update Historical Names" sticky borderBottom />
                    <UpdateHistoricalNames />
                  </Card>
                </LazyTabPane>
              </section>
            </Col>
          </Row >
        </GridContainer>
      </section>
    )
  }
}
